import {
	CModalHeader,
	CModalBody,
	CModalFooter,
	CModal,
	CModalTitle,
} from "@coreui/react"
import "@coreui/coreui/dist/css/coreui.min.css"

import { Pagination } from "@mui/material"

import React from "react"

class EquipmentPopUpComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			trainingDone: false,
			visible: false,
			currentPage: 1,
		}
	}

	setCurrentPage(event, page) {
		this.setState({ currentPage: page })
	}
	onClose_Handler = (e) => {
		this.props.onClose && this.props.onClose(e)
	}
	componentDidMount() {
		this.setState({ visible: this.props.visible })
	}

	render() {
		return (
			<>
				{this.props.equipment && (
					<CModal
						alignment="center"
						size="xl"
						scrollable
						visible={this.state.visible}
						onClose={this.onClose_Handler.bind(this)}
					>
						<CModalHeader>
							<CModalTitle>{this.props.equipment.title}</CModalTitle>
						</CModalHeader>
						<CModalBody>
							{this.props.equipment.pages[this.state.currentPage - 1]}
						</CModalBody>
						<CModalFooter>
							{this.props.equipment.pages.length > 1 ? (
								<Pagination
									count={this.props.equipment.pages.length}
									page={this.state.currentPage}
									onChange={this.setCurrentPage.bind(this)}
								/>
							) : null}
						</CModalFooter>
					</CModal>
				)}
			</>
		)
	}
}

export default EquipmentPopUpComponent
